export default __webpack_public_path__ + "static/media/RegisterWait1.d18a2b1e.JPG";